const HowWeWorkButton = ({ pdfUrl }) => (
    <p className="mt-3 fw-normal text-dark">
        How Instafix 
        <a href={pdfUrl} target="_blank" rel="noopener noreferrer" className="text-success"> Works</a>
    </p>
);

export default HowWeWorkButton;